import { Table, Button, Space, Input, TableColumnsType, Popconfirm } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import useCounterparty from './useCounterparty';
import Page from '../../../../ui/Page';
import RowSpan from '../../../../ui/RowSpan';
import { CounterpartyDtoRequest, CounterpartyDtoResponse } from '../../../../interfaces/CounterpartyDtos';
import MultiLangName from '../../../../ui/Table/MultiLangName';
import useModal from '../../../../ui/Modal/useModal';
import { useState } from 'react';
import CounterpartyModal from './CounterpartyModal';


const CounterpartyPage = () => {
    const { counterparties, counterpartyForm, fetchCounterparties, loading, handleAdd, handleEdit, handleDelete } = useCounterparty();
    const { isModalOpen, handleCancel, showModal: handleShowModal } = useModal();
    const [modalType, setModalType] = useState<'add' | 'edit'>('add');
    const [currentCounterparty, setCurrentCounterparty] = useState<CounterpartyDtoResponse | null>(null);

    const openModal = (type: 'add' | 'edit', counterparty?: CounterpartyDtoResponse) => {
        setModalType(type);
        setCurrentCounterparty(counterparty || null);
        counterpartyForm.setFieldsValue({
            ...counterparty,
            counterPartyFormId: counterparty?.counterPartyForm.id,
        });
        handleShowModal();
    };

    const handleModalCancel = () => {
        counterpartyForm.resetFields();
        handleCancel();
    };

    const handleModalSubmit = (values: CounterpartyDtoRequest) => {
        if (modalType === 'add') {
            handleAdd(values);
        } else if (modalType === 'edit' && currentCounterparty) {
            handleEdit(currentCounterparty.id, values);
        }
        handleCancel();
    };


    const columns: TableColumnsType<CounterpartyDtoResponse> = [
        { title: 'BIN', dataIndex: 'bin', key: 'bin' },
        { title: 'Form', dataIndex: 'counterPartyForm', key: 'counterPartyForm', render: (form) => form.shortNameRu },
        {
            title: 'Name', dataIndex: 'name', key: 'name', width: "10%",
            render(value, record, index) {
                return <MultiLangName nameRu={record.nameRu} nameKz={record.nameKz} nameEn={record.nameEn} />;
            },
        },
        {
            title: 'Address', dataIndex: 'address', key: 'address', width: "20%",
            render(value, record, index) {
                return <MultiLangName nameRu={record.addressRu} nameKz={record.addressKz} nameEn={record.addressEn} />;
            },
        },
        { title: 'Head Fullname', dataIndex: 'headFullname', key: 'headFullname' },
        {
            title: 'Head position', dataIndex: 'headPosition', key: 'headPosition', width: "10%",
            render(value, record, index) {
                return <MultiLangName nameRu={record.headPositionRu} nameKz={record.headPositionKz} nameEn={record.headPositionEn} />;
            },
        },
        { title: 'Representative Fullname', dataIndex: 'representativeFullname', key: 'representativeFullname' },
        { title: 'Representative Phone', dataIndex: 'representativePhoneNumber', key: 'representativePhoneNumber' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        {
            title: 'Actions',
            key: 'actions',
            width: "5%",
            render: (record) => (
                <Space>
                    <Button icon={<EditOutlined />} onClick={() => openModal('edit', record)} />
                    <Popconfirm
                        title="Are you sure you want to delete this counterparty?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button danger type="primary" icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
            ),
        },
    ];



    return (
        <Page title='Counterparties'>
            <RowSpan
                left={
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Input.Search
                            placeholder="Search counterparties"
                            onSearch={fetchCounterparties}
                            enterButton
                            allowClear
                        />
                    </Space>
                }
                right={
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal('add')} style={{ marginBottom: 16 }}>
                        Add Counterparty
                    </Button>
                }
            />
            <Table
                bordered
                columns={columns}
                dataSource={counterparties?.sort((a, b) => a.id - b.id)}
                loading={loading}
                rowKey="id"
            />
            <CounterpartyModal
                visible={isModalOpen}
                type={modalType}
                parentForm={counterpartyForm}
                onClose={handleModalCancel}
                onSubmit={handleModalSubmit}
            />
        </Page>
    );
};

export default CounterpartyPage;